// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"46728eacad8d123591c5","293":"4596adc29cab84f2bc2e"}[chunkId] + ".js";
};